import { CollectionReference, DocumentData, getDocs, query, where } from 'firebase/firestore';
import toast from 'react-hot-toast';

import { strings } from '../../../strings';

/**
 *
 * @param ref ref of collection in Firebase
 * @param name Name of input name of puzzle
 * @returns True if exist and false if not exist in database name
 */

export const checkFieldExist = async (
  ref: CollectionReference<DocumentData>,
  fieldName: string,
  name: string,
) => {
  const checkName = query(ref, where(fieldName, '==', name));
  const data = await getDocs(checkName);
  return new Promise((resolve, reject) => {
    if (!data.empty) {
      resolve(true);
    } else if (data.empty) {
      resolve(false);
    } else {
      reject(toast.error(strings.toastNotificationSomethingWrong));
    }
  });
};
